import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiCustodyExit } from "@/api";
import type { CustodyExitRequest, CustodyExitResponse } from "@/api/types";

export function useCustodyExit() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      data: CustodyExitRequest
    ): Promise<CustodyExitResponse> => {
      const res = await ApiCustodyExit(data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["custodyOrders"] });
      queryClient.invalidateQueries({ queryKey: ["userCustodyInfo"] });
      queryClient.invalidateQueries({ queryKey: ["balanceV2"] });
    },
  });
}
